module.exports = __webpack_public_path__ + "static/media/CLicon02.8d09eb3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/CLicon02.png
// module id = 1705
// module chunks = 0 1